import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";

const ProfileSettings = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Profile Settings" 
        description="Manage your account and preferences"
      >
        <section className="space-y-6">
          <div className="bg-muted/50 border border-border rounded-lg p-6">
            <p className="text-center text-muted-foreground italic">
              ⚙️ Profile settings interface coming soon! Contact office to update your information.
            </p>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">What You Can Update</h2>
          <div className="space-y-4">
            <div className="border-l-4 border-primary pl-4">
              <h3 className="text-lg font-medium">Contact Information</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Phone number</li>
                <li>Email address</li>
                <li>Home address</li>
                <li>Emergency contacts</li>
              </ul>
            </div>
            <div className="border-l-4 border-primary pl-4">
              <h3 className="text-lg font-medium">Account Preferences</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Password</li>
                <li>Notification settings</li>
                <li>Language preference</li>
                <li>Display name</li>
              </ul>
            </div>
            <div className="border-l-4 border-primary pl-4">
              <h3 className="text-lg font-medium">Financial Information</h3>
              <ul className="list-disc list-inside space-y-1 text-muted-foreground ml-4">
                <li>Direct deposit details</li>
                <li>Tax withholding (W-4)</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">How to Update Your Profile</h2>
          <div className="space-y-4">
            <p className="text-muted-foreground">
              Until the self-service portal is complete, please contact the office to update your profile information:
            </p>
            <div className="border border-border rounded-lg p-4">
              <p className="font-medium mb-2">Contact HR</p>
              <ul className="space-y-1 text-sm text-muted-foreground">
                <li><strong>Email:</strong> hr@bluelux.com</li>
                <li><strong>Phone:</strong> (619) 555-0100</li>
                <li><strong>Hours:</strong> Monday-Friday, 8:00 AM - 5:00 PM</li>
              </ul>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Important Reminders</h2>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Update emergency contacts immediately if they change</li>
            <li>Keep your phone number current so office can reach you</li>
            <li>If you move, update your address within 7 days (affects route assignments)</li>
            <li>Review your direct deposit information before each pay period</li>
          </ul>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default ProfileSettings;